"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaffleRoundEndButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const endRound_json_1 = __importDefault(require("@framework/abis/json/RaffleRandom/endRound.json"));
const utils_1 = require("../../../../../utils");
const hooks_1 = require("../../../../../hooks");
const RaffleRoundEndButton = (props) => {
    const { className, contract, contract: { address, parameters }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE, contract?.id);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async () => {
        return writeContractAsync({
            address: address,
            abi: endRound_json_1.default,
            functionName: "endRound",
        });
    });
    const handleEndRound = () => {
        return metaFn();
    };
    // round not started
    if (!parameters.roundId) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleEndRound, icon: icons_material_1.StopCircleOutlined, message: "pages.raffle.rounds.end", className: className, dataTestId: "RaffleRoundEndButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }));
};
exports.RaffleRoundEndButton = RaffleRoundEndButton;
//# sourceMappingURL=index.js.map